module.exports = __webpack_public_path__ + "static/image/reporter-p3.svg?08d447edec58526ab88912df539bbf99";